import { Contract, utils, providers } from 'ethers'

import ABI from './abi'

export const CHAIN_ID = 1

export const OLD_TOKEN_ADDRESS = '0x0cf0ee63788a0849fe5297f3407f701e122cc023'

export const NEW_TOKEN_ADDRESS = '0x8f693ca8d21b157107184d29d398a8d082b38b76'

export const DATA_FUND_CONTRACT_ADDRESS = '0xf967622d4e753f9429e35127dccdc73713db630b'

export const MARKETPLACE_CONTRACT_ADDRESS = '0x2b3f2887c697b3f4f8d9f818c95482e1a3a759a5'

export const INFURA_ID = '17c3985baecb4c4d94a1edc2c4d23206'

export function getPublicNodeProvider() {
    // Use the mainnet
    const network = 'homestead'
    const provider = new providers.InfuraProvider(network, {
        projectId: INFURA_ID,
    })
    return provider
}

export function getTokens() {
    const provider = getPublicNodeProvider()

    return {
        // New DATA token contract
        dataToken: new Contract(NEW_TOKEN_ADDRESS, ABI, provider),
        // Old DATA token contract (-> XDATA)
        xdataToken: new Contract(OLD_TOKEN_ADDRESS, ABI, provider),
    }
}

// eslint-disable-next-line import/no-unused-modules
export async function getERC20TokenBalance(address, tokenAddress) {
    const abi = [
        {
            name: 'balanceOf',
            type: 'function',
            inputs: [
                {
                    name: '_owner',
                    type: 'address',
                },
            ],
            outputs: [
                {
                    name: 'balance',
                    type: 'uint256',
                },
            ],
            constant: true,
            payable: false,
        },
    ]

    const provider = getPublicNodeProvider()
    const contract = new Contract(
        tokenAddress,
        abi,
        provider,
    )

    const balance = await contract.balanceOf(address)
    return parseFloat(utils.formatEther(balance, 18))
}

// eslint-disable-next-line import/no-unused-modules
export async function getDataPerUsdRate(marketplaceContractAddress) {
    const abi = [
        {
            constant: true,
            inputs: [],
            name: 'dataPerUsd',
            outputs: [
                {
                    internalType: 'uint256',
                    name: '',
                    type: 'uint256',
                },
            ],
            payable: false,
            stateMutability: 'view',
            type: 'function',
        },
    ]

    const provider = getPublicNodeProvider()
    const contract = new Contract(
        marketplaceContractAddress,
        abi,
        provider,
    )

    const dataPerUsd = await contract.dataPerUsd()
    return parseFloat(utils.formatEther(dataPerUsd, 18))
}
